$( document ).ready(function() {
    if($('.page-template-template-accueil').length) {
    var newEvents = [];
    $('#events-content .event-ajax-item').each(function(index, item) {
        if($(item).attr('data-debut')) {
            var dateDebut = $(item).attr('data-debut');
            var dateFin = dateDebut;
            if($(item).attr('data-fin')) dateFin = $(item).attr('data-fin');
            newEvents.push({
                startDate: dateDebut,
                endDate: dateFin,
                summary: $(item).attr('data-title'),
                link: $(item).attr('data-link'),
            })
        }
    })
    calendarOptions.events = newEvents;
    $('#accueil-calendar').simpleCalendar(calendarOptions);

	setTimeout(function() {
        $("#splash").trigger('click');
    },10);
}
// Add smooth scrolling to .header-content's link
$(".scroll a").on('click', function(e) {
	// Make sure this.hash has a value before overriding default behavior
	if (this.hash !== "") {
	  // Prevent default anchor click behavior
	  e.preventDefault();
	  // Store hash
	  var hash = this.hash;
	  // Using jQuery's animate() method to add smooth page scroll
	  // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
	  $('html, body').animate({
		scrollTop: $(hash).offset().top
	  }, 800, function(){
		// Add hash (#) to URL when done scrolling (default click behavior)
		window.location.hash = hash;
	  });
	} // End if
  });
	$('.weather').openWeather({
        key : '0113145665a723731c7d757bda7b52c4',
        lang : 'fr',
        iconTarget: '.weather-icon',
        customIcons: '',
        city: 'Limbourg, BE',
        units: 'c'
    });
	posScroll = window.pageYOffset;
	$('header .bars').click(function(){
		$(this).toggleClass('active');
		$('nav').toggleClass('active');
		$(this).parent().toggleClass('open');
	});
	/*$('nav ul>li:not(.dropdown)>a').click(function(){
		$('nav').removeClass('active');
		$('header .bars').removeClass('active');
	});*/
	$('.slider-events').slick({
		dots: true,
		arrows: false
	});
	var btn = $('.top');
	btn.on('click', function(e) {
	  e.preventDefault();
	  $('html, body').animate({scrollTop:0}, '300');
	});
$(window).scroll(function(){
		if(posScroll >=650 ) {
			$('.top').fadeIn(100);
			//console.log('FADE IN');
			//console.log(posScroll);
		} else {
				$('.top').fadeOut(100);
			//console.log('FADE OUT');
			//console.log(posScroll);
		}
		posScroll = window.pageYOffset;
	});
	// Animation flèches de sélection de mois, agenda.html
	$('#previousMonth').hover(function(){
		$('#previousMonth').css("padding-right", "2em");
    	}, function(){
		$('#previousMonth').css("padding-right", "1em");
	});
	$('#nextMonth').hover(function(){
		$('#nextMonth').css("padding-left", "2em");
    	}, function(){
		$('#nextMonth').css("padding-left", "1em");
	});
	// Animation Formulaire contact.html
	$('input').focus(function(){
		$(this).parents('.form-group').addClass('focused');
	  });
	  $('input').blur(function(){
		var inputValue = $(this).val();
		if ( inputValue == "" ) {
		  $(this).removeClass('filled');
		  $(this).parents('.form-group').removeClass('focused');
		} else {
		  $(this).addClass('filled');
		}
	  })
	  // Animation btn découvrir decouvrir-villages.html
	  $('#nos-villages article').hover(function(){
		$(this).find('.btn-decouvrir i').css("padding-left", "1em");
		}, function(){
		$('.btn-decouvrir i').css("padding-left", "0em");
	  });
	  // Menu déroulant
	  $('.sub-menu').hide();
	  $('#menu-gauche .menu-item-has-children >a, #menu-droite .menu-item-has-children >a').click(function(e){
		e.preventDefault();
		var currentContent = $(this).siblings('.sub-menu');
		var currentLi = $(this).parent();
        $('.sub-menu').not(currentContent).slideUp('.3s');
		currentContent.css("margin-top", "0").slideToggle('.3s');
		$('#menu-gauche .menu-item-has-children >a, #menu-droite .menu-item-has-children >a')
		.parent().not(currentLi).removeClass('unroll');
		currentLi.toggleClass('unroll');
	  });
	  $('#footer-menu .menu-item-has-children >a').click(function(e){
		e.preventDefault();
		$(this).parent().find('.sub-menu')
				.css("margin-top", "0")
				.slideToggle('.3s');
		$(this).parent().toggleClass('unroll');
	  });
      // agenda
      function loadAgenda(month, year) {
			$('.months_agenda').addClass('loading')
          	$('#month-title').html(months[month-1] + ' ' + year)
			$.ajax(baseUrl + '/ajax-get-agenda.php?month='+month+'&year='+year, {
				success: function(data) {
					$('.months_agenda').removeClass('loading')
					$('#agenda-load').html(data);
					
				}
			})
      }
      if($('.months_agenda').length) {
        $('#previousMonth').click(function(e) {
            e.preventDefault();
            var curMonth = $('#month-title').attr('data-month');
            var curYear = $('#month-title').attr('data-year');
            if(curMonth == 1) {
                curMonth = 12;
                curYear--;
            } else {
                curMonth--;
            }
            $('#month-title').attr('data-month', curMonth);
            $('#month-title').attr('data-year', curYear);
            loadAgenda(curMonth, curYear)
        });
        $('#nextMonth').click(function(e) {
            e.preventDefault();
            var curMonth = $('#month-title').attr('data-month');
            var curYear = $('#month-title').attr('data-year');
            if(curMonth == 12) {
                curMonth = 1;
                curYear++;
            } else {
                curMonth++;
            }
            $('#month-title').attr('data-month', curMonth);
            $('#month-title').attr('data-year', curYear);
            loadAgenda(curMonth, curYear)
        });
      }
	//   $('.months_agenda').slick({
	// 	dots: true,
	// 	infinite : false,
	// 	arrows: true,
	// 	appendArrows : '#month-select',
	// 	prevArrow : '<a href="#" id="previousMonth"><i class="fas fa-chevron-left"></i></a>',
	// 	nextArrow : '<a href="#" id="nextMonth"><i class="fas fa-chevron-right"></i></a> ',
	// });
	$('.search_toggle').on('click',function(e){
		e.preventDefault();
		$('.searchform').toggleClass('open');
		$('.searchform #s').focus();
		if($(this).hasClass('open')){
			
			$(this).removeClass('open');
			$('.searchform').submit();
		}else{
			
			$(this).addClass('open');
		}
	});
	$(document).mouseup(function(e) 
	{
		var container = $(".searchform");
		// if the target of the click isn't the container nor a descendant of the container
		if (!container.is(e.target) && container.has(e.target).length === 0) 
		{
			container.removeClass('open');
		}
	});
});
